import { APIProvider, Map, Marker } from "@vis.gl/react-google-maps";

const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

export default function LocationMap({ lat, lng }) {
  if (!API_KEY || lat == null || lng == null) {
    return <div className="flex h-56 items-center justify-center border border-zinc-200 bg-zinc-50 text-xs text-zinc-400">No map location set</div>;
  }
  const center = { lat: Number(lat), lng: Number(lng) };
  return (
    <div className="h-56 w-full overflow-hidden border border-zinc-200" data-testid="location-map">
      <APIProvider apiKey={API_KEY}>
        <Map defaultCenter={center} defaultZoom={15} gestureHandling="greedy" disableDefaultUI={false}>
          <Marker position={center} />
        </Map>
      </APIProvider>
    </div>
  );
}
